export default "__VITE_ASSET__CzSZrngE__"